import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Descriptions } from 'antd';
import Header from './header';
import Sidebar from './sidebar';

const PlanningDetails = () => {
    const { id } = useParams();
    const [planningDetails, setPlanningDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPlanningDetails = async () => {
            try {
                const response = await axios.get(`https://ward3-chandrapur-api.palikaapp.com/api/planning/${id}/details`);
                setPlanningDetails(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchPlanningDetails();
    }, [id]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <strong className="font-bold">Error: </strong>
                    <span className="block sm:inline">{error.message}</span>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <Header />
            <div className="flex flex-1 pt-20">
                <Sidebar />
                <main className="flex-1 p-4 sm:p-6 lg:p-8">
                    <div className="container mx-auto max-w-2xl">
                        <div className="bg-gray-100 shadow-md rounded-lg overflow-hidden">
                            <div className="p-6">
                                <h1 className="text-2xl font-bold text-center mb-6 pb-4 border-b">
                                    योजनाको बिस्तृत विवरण
                                </h1>

                                <div className="space-y-4">
                                    <div className="flex justify-between border-b pb-2">
                                        <span className="font-semibold text-gray-600">सिर्शक</span>
                                        <span className="text-right">{planningDetails.title}</span>
                                    </div>

                                    <div className="flex justify-between border-b pb-2">
                                        <span className="font-semibold text-gray-600">विवरण</span>
                                        <span className="text-right">{planningDetails.description}</span>
                                    </div>

                                    <div className="flex justify-between border-b pb-2">
                                        <span className="font-semibold text-gray-600">रकम</span>
                                        <span className="text-right">{planningDetails.budget}</span>
                                    </div>

                                    <div className="flex justify-between border-b pb-2">
                                        <span className="font-semibold text-gray-600">वर्ष</span>
                                        <span className="text-right">{planningDetails.fiscalYearName}</span>
                                    </div>

                                    <div className="flex justify-between border-b pb-2">
                                        <span className="font-semibold text-gray-600">योजना प्रकार</span>
                                        <span className="text-right">{planningDetails.planningCategory}</span>
                                    </div>

                                    <div className="flex justify-between pb-2">
                                        <span className="font-semibold text-gray-600">वडा</span>
                                        <span className="text-right">{planningDetails.wardName}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default PlanningDetails;